import { apiTransport } from '@services/rest-api';
import { AdapterFunction } from '../types';
import { Institution } from '@models/institution';

interface GetByIdParams {
  institutionId: string;
}

const getById: AdapterFunction<Institution, GetByIdParams> = (
  { institutionId },
  { signal }
) => {
  const url = `/v1/institutions/${institutionId}`;

  const response = apiTransport.get<Institution>({
    url,
    config: {
      signal
    }
  });

  return response;
};

export type { GetByIdParams };
export { getById };
